/* MEMBER HUB 補助スクリプト: 進捗バーの初回表示アニメーションのみ。
   JS無効でもバーは最終値で表示される(width はCSS変数で確定済み)。 */
(function () {
  'use strict';

  function init() {
    var fills = document.querySelectorAll('[data-nini-hub-progress]');
    if (!fills.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    fills.forEach(function (fill) {
      if (fill.dataset.niniHubInit === '1') return;
      fill.dataset.niniHubInit = '1';
      var target = fill.style.getPropertyValue('--nini-hub-progress');
      fill.style.width = '0%';

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          requestAnimationFrame(function () {
            fill.classList.add('is-animating');
            fill.style.width = target;
          });
        });
      }, { threshold: 0.4 });
      observer.observe(fill);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
